/* loading.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
        <svg viewBox="0 0 59.3 40" preserveAspectRatio="none">
            <g>
                <path fill="black" id="svg_2" d="m55.33708,16.01344c2.2,0 3.9,1.8 3.9,3.9s-1.7,4 -3.9,4c-2.2,0 -3.9,-1.8 -3.9,-3.9s1.8,-4 3.9,-4zm-12.5,-1c2.7,0 4.9,2.2 4.9,4.9c0,2.7 -2.2,4.9 -4.9,4.9s-4.9,-2.2 -4.9,-4.9c0,-2.7 2.2,-4.9 4.9,-4.9zm-16.2,-1.3c3.4,0 6.2,2.8 6.2,6.2c0,3.4 -2.8,6.2 -6.2,6.2c-3.4,0 -6.2,-2.8 -6.2,-6.2c0,-3.4 2.8,-6.2 6.2,-6.2zm-18.6,-1.8c4.4,0 8,3.6 8,8c0,4.4 -3.6,8 -8,8s-8,-3.6 -8,-8c0,-4.4 3.6,-8 8,-8z" class="foreground-gl"/>
            </g>
        </svg>
    `
};